// Ширина штриха-полосы гайда отступа в px холста. Полоса центрирована на контуре
// детали и обрезана по нему клипом → видна только внутренняя половина шириной ~marginMm.
// Поэтому штрих в 2× шире безопасного отступа. Units: 100 = 1мм, s — px за unit.
export function safeMarginBandPx(marginMm, s) {
  if (!(s > 0)) return 0
  return marginMm * 100 * s * 2
}
